import React from "react";

import DataGrid, {
  Editing,
  Selection,
  FilterRow,
  Pager,
  Paging,
  Column,
  Item,
  Popup,
  Form
} from "devextreme-react/data-grid";
import { axios } from "../../../common";

export default function CommonSettingTable({ dataSource = [] }) {
  const [columns, setColumns] = React.useState([]);

  React.useEffect(() => {
    const fetchColumn = async () => {
      const { data } = await axios.get("ScreenSetting", {
        params: {
          $filter: "ScreenCode eq 'P0054'",
        },
      });
      setColumns(data.value);
    };
    fetchColumn();
  }, []);
  return (
    <>
      <DataGrid
        dataSource={dataSource}
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />

        <Editing
          mode="popup"
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}
        >
          <Popup
            showTitle={true}
            width={800}
            height={525}
          />
          <Form>
            <Item itemType="group" colCount={2} colSpan={2}>
              <Item dataField="Category"></Item>
              <Item dataField="Key"></Item>
              <Item dataField="IsActive" ></Item>
              <Item dataField="Value" editorType="dxTextArea"></Item>
            </Item>
            <Item itemType="group" colCount={2} colSpan={2}>
              <Item
                dataField="Remarks"
                editorType="dxTextArea"
                colSpan={2}
              ></Item>
            </Item>
          </Form>
        </Editing>

        {columns?.map((column) => {
          const { DataField, Caption, DataType, VisibleIndex, Visible } =
            column;
          return (
            <Column
              key={DataField}
              dataField={DataField}
              caption={Caption}
              type={DataType}
              visibleIndex={VisibleIndex}
              visible={Visible}
              allowEditing={true}
              allowAdding={true}
            />
          );
        })}
      </DataGrid>
    </>
  );
}
